export default {
  type: "comments",
  comment: "",
  relationshipNames: ["organization", "object", "replyTo"],
  organization: {
    type: "organizations",
    id: null,
  },
  object: {
    type: null,
    id: null,
  },
  replyTo: null,
};
